import MerchBox, { MerchBoxSize } from './MerchBox';

export interface PlpMerchBoxesProps {
  data: {
    numberOfBoxes: string;
    boxes: {
      title: string;
      url: string;
      image: {
        alt: string;
        url: string;
        dimensions: {
          width: number;
          height: number;
        };
      };
    }[];
  };
  locale?: string;
  hasPlpBanner?: boolean;
}

const PlpMerchBoxes = ({ data, locale, hasPlpBanner }: PlpMerchBoxesProps) => {
  if (!data) return null;
  const { boxes, numberOfBoxes } = data;
  if (boxes.length < parseInt(numberOfBoxes)) return null;
  return (
    <div className="merchZoneContainer">
      {boxes?.map((item) => {
        if (!item.title || !item.url) return null;
        return (
          <MerchBox
            key={item?.title}
            title={item?.title}
            url={`/${locale}${item?.url}`}
            image={item?.image}
            merchBoxSize={
              numberOfBoxes === '3' ? MerchBoxSize?.Large : MerchBoxSize?.Small
            }
            hasPlpBanner={hasPlpBanner}
          />
        );
      })}
    </div>
  );
};

export default PlpMerchBoxes;
